export const TermsOfServicePage = () => {
  return (
    <section className="min-h-[70vh] bg-cream py-20" data-testid="terms-of-service-page">
      <div className="container-custom max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-heading font-bold text-forest mb-8">Terms of Service</h1>
        <div className="space-y-6 text-forest/80 leading-relaxed">
          <p>
            By using this website, you agree to use it lawfully and in accordance with these terms.
          </p>
          <p>
            All content on this site is provided for general information about Warner Digital Media services
            and may be updated at any time.
          </p>
          <p>
            Project timelines, deliverables, and fees are defined in separate client agreements.
          </p>
          <p>
            If you do not agree with these terms, please discontinue use of this website.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TermsOfServicePage;
